var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import styled from "../themes/styled";
import Text from "./Text";
import * as SS from "styled-system";
import { ifProp } from "styled-tools";
export var List = styled.ul.attrs(function () {
    return { pl: 5 };
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    list-style-position: outside;\n    li {\n        list-style-type: ", ";\n        display: list-item;\n    }\n"], ["\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    list-style-position: outside;\n    li {\n        list-style-type: ", ";\n        display: list-item;\n    }\n"])), SS.background, SS.border, SS.boxShadow, SS.color, SS.flexbox, SS.grid, SS.layout, SS.position, SS.space, SS.typography, ifProp({ as: "ol" }, "decimal", "disc"));
export var ListItem = function (props) { return React.createElement(Text, __assign({ as: "li", typeStyle: "body" }, props)); };
var templateObject_1;
//# sourceMappingURL=List.js.map